export default __webpack_public_path__ + "static/media/2Pblue_GW152.ce05a12d.png";